export const featureToggles = {
  //ADD FEATURE TOGGLES IN LOWERCASE LETTERS IN THIS FILE
  'feature-flag-test': false,
  pay_v4_payment_methods_enabled: false, //https://glovoapp.atlassian.net/browse/FTP-1562
  customer_help_center_enabled: false, // https://glovoapp.atlassian.net/browse/WEBX-698
  lc_fe_dh_courier_chat_enabled: false, // https://glovoapp.atlassian.net/browse/WEBX-699
  glovo_web_open_api_pilot_enabled: false, // https://glovoapp.atlassian.net/browse/WP-4697
  lc_fe_disable_cc_chat: false, // https://glovoapp.atlassian.net/browse/WEBX-720
  webx_react_dh_help_center_enabled: false, // https://glovoapp.atlassian.net/browse/WEBX-714
  webx_react_past_orders_enabled: false, // https://glovoapp.atlassian.net/browse/WEBX-749
} as const
